import { api } from './client';

const P = '/api/erm/payroll';

/** HR and the managing director: salaries, monthly runs, letters, settings. */
export const payroll = {
  settings: () => api.get(`${P}/settings`),
  saveSettings: (b) => api.put(`${P}/settings`, b),

  salaries: () => api.get(`${P}/salaries`),
  salary: (employeeId) => api.get(`${P}/salaries/${employeeId}`),
  saveProfile: (employeeId, b) => api.put(`${P}/salaries/${employeeId}/profile`, b),
  addRevision: (employeeId, b) => api.post(`${P}/salaries/${employeeId}/revisions`, b),
  deleteRevision: (employeeId, rateId) => api.del(`${P}/salaries/${employeeId}/revisions/${rateId}`),
  addItem: (employeeId, b) => api.post(`${P}/salaries/${employeeId}/items`, b),
  saveItem: (employeeId, itemId, b) => api.put(`${P}/salaries/${employeeId}/items/${itemId}`, b),
  deleteItem: (employeeId, itemId) => api.del(`${P}/salaries/${employeeId}/items/${itemId}`),

  runs: () => api.get(`${P}/runs`),
  createRun: (period) => api.post(`${P}/runs`, { period }),
  run: (id) => api.get(`${P}/runs/${id}`),
  deleteRun: (id) => api.del(`${P}/runs/${id}`),
  recompute: (id) => api.post(`${P}/runs/${id}/recompute`),
  lock: (id) => api.post(`${P}/runs/${id}/lock`),
  unlock: (id) => api.post(`${P}/runs/${id}/unlock`),
  release: (id) => api.post(`${P}/runs/${id}/release`),
  slip: (id, employeeId) => api.get(`${P}/runs/${id}/payslips/${employeeId}`),
  updateSlip: (id, employeeId, b) => api.patch(`${P}/runs/${id}/payslips/${employeeId}`, b),
  releaseHeld: (id, employeeId) => api.post(`${P}/runs/${id}/payslips/${employeeId}/release`),
  addAdjustment: (id, employeeId, b) => api.post(`${P}/runs/${id}/payslips/${employeeId}/adjustments`, b),
  deleteAdjustment: (id, adjustmentId) => api.del(`${P}/runs/${id}/adjustments/${adjustmentId}`),
  importAdjustments: (id, b) => api.post(`${P}/runs/${id}/adjustments/import`, b),
  register: (id) => api.get(`${P}/runs/${id}/export/register`),
  bankFile: (id) => api.get(`${P}/runs/${id}/export/bank`),

  documents: (employeeId) => api.get(`${P}/documents${employeeId ? `?employeeId=${employeeId}` : ''}`),
  uploadDocument: ({ employeeId, type, title, issuedOn, file }) => {
    const form = new FormData();
    form.append('employeeId', employeeId);
    form.append('type', type);
    if (title) form.append('title', title);
    if (issuedOn) form.append('issuedOn', issuedOn);
    form.append('file', file);
    return api.upload(`${P}/documents`, form);
  },
  deleteDocument: (id) => api.del(`${P}/documents/${id}`),
  documentUrl: (id) => api.get(`${P}/documents/${id}/url`),
};

/** The signed-in employee's own pay. */
export const myPay = {
  payslips: () => api.get('/api/erm/pay/me/payslips'),
  payslip: (id) => api.get(`/api/erm/pay/me/payslips/${id}`),
  documents: () => api.get('/api/erm/pay/me/documents'),
  documentUrl: (id) => api.get(`/api/erm/pay/me/documents/${id}/url`),
};

/** Saves a {filename, csv} export from the server as a file. */
export function saveCsv({ filename, csv }) {
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

const inr = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
/** ₹1,23,456 - whole rupees, Indian grouping. */
export const money = (v) => (v === null || v === undefined || v === '' ? '—' : inr.format(Number(v)));

/** "2026-10" -> "October 2026". */
export function monthLabel(period) {
  if (!period) return '';
  const [y, m] = period.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('en-IN', { month: 'long', year: 'numeric' });
}

/** 2.5 -> "2.5", 3 -> "3". */
export const days = (d) => (d === null || d === undefined ? '—' : String(Number(d)));
